// Auto-generated by scripts/generate-version.js - DO NOT EDIT
export const packageVersion = '0.2.2';
